import Mock from './index';
import {
  getByCode, login, getStudentList, delteStudent,
  getUserList,
  resetPassword,
  delteTeacher,
  changeUserName,
  createUser,
} from './modules/user';
import {
  getClassList, editClass, delClass, insertStudent,
} from './modules/classe';
import { changeUserSignatures, changePasswords } from './modules/public/userInfo';
import { delJobView, queryJobView } from './modules/job';
import { delCaseAnalysis, queryCaseAnalysis } from './modules/caseAnalysis';
import { delJobDetailListItem, queryJobDetailList } from './modules/jobDetailList';
import { delJobBasicInfo, queryJobBasicInfo, saveJobBasicInfo } from './modules/jobBasicInfo';
import { delQuestion, queryQuestionList } from './modules/questoinList';
import { delQuestionModule, queryQuestionModules } from './modules/questionModule';
import { getPreviewData } from './modules/jobPreview';

export default class MockPath {
    login = './mock/user/login';

    getByCode = './mock/user/getByCode';

    getClassList = './mock/class/queryClass'

    editClass = './mock/class/createOrUpdateClass'

    delClass = './mock/userManage/delClass'

    insertStudent = './mock/classMember/insertStudent'

    getUserList = './mock/user/queryUserList'

    getStudentList = './mock/classMember/listStudent'

    resetPassword = './mock/user/adminResetPassword'

    delteTeacher = './mock/userManage/delTeacher'

    delteStudent = './mock/userManage/delStudent'

    changeUserName = './mock/user/changeUserInfo'

    createUser = './mock/classMember/createClassMember'

    changeUserSignatures = './mock/user/changeUserSignature'

    changePasswords = './mock/user/changePassword'

    /**
     * 作业相关接口
     */
    getJobView = './mock/job/queryJobView';

    delJobView = './mock/job/delJobView';

    getCaseAnalysis = './mock/job/queryCaseAnalysis';

    delCaseAnalysis = './mock/job/delCaseAnasysis';

    getJobDetailList = './mock/jobDetailList/queryJobDetailList';

    delJobDetailListItem = './mock/jobDetailList/delJobDetailListItem';

    getJobBasicInfo = './mock/jobBasicInfo/queryJobBasicInfo';

    delJobBasicInfo = './mock/jobBasicInfo/delJobBasicInfo';

    saveJobBasicInfo = './mock/jobBasicInfo/saveJobBasicInfo';

    getQuestionList = './mock/questionList/queryQuestionList';

    delQuestion = './mock/question/delQuestion';

    getQuestionModules = './mock/questionModule/queryQuestionModules'

    delQuestionModule = './mock/questionModule/delQuestionModule'

    getPreviewData = './mock/questionModule/getPreviewData'
}

const mockPath = new MockPath();
// 登录模块
Mock.mock(mockPath.login, 'post', login);
Mock.mock(mockPath.getByCode, 'post', getByCode);

// 班级模块
Mock.mock(mockPath.getClassList, 'post', getClassList);
Mock.mock(mockPath.editClass, 'post', editClass);
Mock.mock(mockPath.delClass, 'post', delClass);
Mock.mock(mockPath.insertStudent, 'post', insertStudent);

// 教师列表
Mock.mock(mockPath.getUserList, 'post', getUserList);
// 学生列表
Mock.mock(mockPath.getStudentList, 'post', getStudentList);
// 重置密码
Mock.mock(mockPath.resetPassword, 'post', resetPassword);
// 删除教师
Mock.mock(mockPath.delteTeacher, 'post', delteTeacher);
// 删除学生
Mock.mock(mockPath.delteStudent, 'post', delteStudent);
// 编辑用户姓名
Mock.mock(mockPath.changeUserName, 'post', changeUserName);
// 添加用户
Mock.mock(mockPath.createUser, 'post', createUser);
// 更改个人信息
Mock.mock(mockPath.changeUserSignatures, 'post', changeUserSignatures);
// 修改密码
Mock.mock(mockPath.changePasswords, 'post', changePasswords);

Mock.mock(mockPath.getJobView, 'post', queryJobView);

Mock.mock(mockPath.delJobView, 'post', delJobView);

Mock.mock(mockPath.getCaseAnalysis, 'post', queryCaseAnalysis);

Mock.mock(mockPath.delCaseAnalysis, 'post', delCaseAnalysis);

Mock.mock(mockPath.getJobDetailList, 'post', queryJobDetailList);

Mock.mock(mockPath.delJobDetailListItem, 'post', delJobDetailListItem);

Mock.mock(mockPath.getJobBasicInfo, 'post', queryJobBasicInfo);

Mock.mock(mockPath.delJobBasicInfo, 'post', delJobBasicInfo);

Mock.mock(mockPath.saveJobBasicInfo, 'post', saveJobBasicInfo);

Mock.mock(mockPath.getQuestionList, 'post', queryQuestionList);

Mock.mock(mockPath.delQuestion, 'post', delQuestion);

Mock.mock(mockPath.getQuestionModules, 'post', queryQuestionModules);

Mock.mock(mockPath.delQuestionModule, 'post', delQuestionModule);

Mock.mock(mockPath.getPreviewData, 'post', getPreviewData);
